export default [

  {
    value: 'login',
    text: 'Кому',
    type: 'string',
    sortable: false,
    description: ''
  },
  // {
  //   value: 'fullName',
  //   text: 'Полное имя',
  //   width: 160,
  //   type: 'string',
  //   sortable: false,
  //   description: ''
  // },
  {
    value: 'profileName',
    text: 'Профиль',
    type: 'string',
    sortable: true,
    description: ''
  },
  {
    value: 'profileType',
    text: 'Тип профиля',
    type: 'string',
    sortable: true,
    description: ''
  },
  {
    value: 'status',
    text: 'Статус',
    width: 120,
    type: 'string',
    sortable: true,
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Дата запроса',
    width: 180,
    type: 'date',
    sortable: true,
    description: ''
  },
  {
    value: 'updatedAt',
    text: 'Дата предоставления',
    width: 180,
    type: 'date',
    sortable: true,
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
